/**
 * Per-tab presence registry of "unsaved work" contexts, fed by <ConfirmExit>
 * instances. Used, best-effort, to warn the user (informational only — never
 * blocking) that other tabs hold unsaved changes before a coordinated update
 * reload.
 *
 * Singleton per tab (module-level Set). Each <ConfirmExit> registers a stable id
 * while it should block navigation, and unregisters otherwise / on unmount. The
 * human-readable label shown in the update modal is derived from the tab's
 * `document.title` at collection time (see app-version-update.store), not stored
 * here — so this registry only answers "does this tab hold unsaved work?". Pure
 * and synchronous, so it is trivially testable.
 */
const ids = new Set<string>();

export const UNSAVED_WORK_MESSAGE = "Vous avez des changements non enregistrés";

export const register = (id: string): void => {
  ids.add(id);
};

export const unregister = (id: string): void => {
  ids.delete(id);
};

export const hasUnsavedWork = (): boolean => ids.size > 0;
